module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/flow-arrow-09159713c6e185e9c0b7a091f214cb30.png";